import BaseListPage from "../../base/BaseListPage";
import withRouter from "../../withRouter";
import { countObjectUseCase, findObjectUseCase } from "../../usecases/object";
import NavBar from "../../components/navbar";
import schemaDashboard from "./schemaDashboard.json";
import CustomerPresenter from "./CustomerPresenter";
import CustomerCountPage from "./chart/customer-count/CustomerCountPage";
import SalesPerSegmentPage from "./chart/sales-per-segment/SalesPerSegmentPage";
import CustomerBreakdownPage from "./chart/customer-breakdown/CustomerBreakdownPage";
import Top5ProductsBuyPage from "./chart/top5-products-buy/Top5ProductsBuyPage";
import CustomerSalesPerStorePage from "./chart/customer-sales-per-store/CustomerSalesPerStorePage";
import ProgressLoader from "../../components/ProgressLoader";

class CustomerPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new CustomerPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase()
    );
    this.state = {
      objects: [],
      selected: [],
      progress: true,
      count: 0,
      where: {},
      selectedOption: "",
      store: [],
      storess: "",
      range: "",
      loading: false, // Add loading state to manage progress
      notFound: false,
      enriched: null,
      totalChunks: 0,
      runningChunks: 0,
    };
  }

  getCollectionName() {
    return "transactions";
  }

  onChangeDate(where) {
    this.presenter.onChangeDate(where);
    this.setState({ range: where });
  }

  onChangeStore(where) {
    this.presenter.onChangeStore(where);
    this.setState({ storess: where });
  }

  getValueForDashboardObject(object) {
    switch (object.label) {
      case "Total Item Sold":
        return this.presenter.calculateTotalItemSoldSalesInfo();
      case "Total Transaction":
        return this.presenter.calculateTotalTransactionInfo();
      case "Total Guest":
        return this.presenter.calculateTotalGuestInfo();
      case "Discount Cost":
        return this.presenter.calculateDiscountCost();
      default:
        return { value: 0, percentage: 0 };
    }
  }

  handleCountClick(nav) {
    this.navigateTo(nav);
  }

  handleSelectChange = (event) => {
    this.setState({ selectedOption: event.target.value, loading: true });

    setTimeout(() => {
      this.setState({ loading: false });
    }, 1000);
  };

  setStore(store) {
    this.setState({ store });
  }

  getProgressPercentage() {
    const { runningChunks, totalChunks } = this.state;
    if (!totalChunks || totalChunks === 0) return 0;
    return Math.min(Math.round((runningChunks / totalChunks) * 100), 100);
  }
  // getProgressPercentage() {
  //   const { enrichedCount, baseCustomerCount } = this.state;
  //   if (!baseCustomerCount || baseCustomerCount === 0) return 0;

  //   const percent = (enrichedCount / baseCustomerCount) * 100;

  //   // 🎯 Treat anything between 95% and 100% as done
  //   if (percent >= 95 && percent < 100) return 100;

  //   return Math.min(Math.round(percent), 100);
  // }

  setNotFound(notFound) {
    this.setState({ notFound });
  }

  setEnrichedTransactions(enriched) {
    this.setState({ enriched: enriched });
  }

  setAllChunks(totalChunks) {
    this.setState({ totalChunks: totalChunks });
  }

  setRunningChunks(runningChunks) {
    this.setState({ runningChunks: runningChunks });
  }

  render() {
    const { objects, enriched, totalChunks, store, loading } = this.state;

    console.log("Enriched", enriched);
    console.log("totalChunks", totalChunks);

    return (
      <>
        <NavBar />
        <div className="overflow-auto">
          <div className="p-3 p-lg-4">
            <div className="d-flex justify-content-between align-items-center">
              <h1
                className="fw-bold mt-3 text-capitalize"
                style={{ color: "#83c14a" }}
              >
                Customer Analytics
              </h1>
            </div>

            <div className="row mt-1 g-3">
              {schemaDashboard.map((card) => (
                <div className="col-md-4 col-6" key={card.label}>
                  <div
                    className="card p-2"
                    style={{ backgroundColor: card.bg }}
                  >
                    <h6 className="fw-bold">{card.label}</h6>
                    <p style={{ fontSize: "14px", color: "#6e93d3" }}>
                      {card.spend}
                    </p>
                    <p style={{ fontSize: "14px", color: "#51d1f6" }}>
                      {card.transaction}
                    </p>
                    {/* <p style={{ fontSize: "14px", color: "#d4bb58" }}>
                      {card.Recency}
                    </p> */}
                  </div>
                </div>
              ))}
            </div>

            <ProgressLoader
              loaded={this.state.runningChunks}
              total={this.state.totalChunks}
              getProgressPercentage={() => this.getProgressPercentage()}
            />

            <CustomerCountPage
              transactions={enriched || []}
              onChangeDate={this.onChangeDate.bind(this)}
              onChangeStore={this.onChangeStore.bind(this)}
              dateField="tran_date"
              store={store}
              storess={this.state.storess}
              range={this.state.range}
              notFound={this.state.notFound}
            />
            <SalesPerSegmentPage
              transactions={enriched || []}
              onChangeDate={this.onChangeDate.bind(this)}
              onChangeStore={this.onChangeStore.bind(this)}
              dateField="tran_date"
              store={store}
              storess={this.state.storess}
              range={this.state.range}
              notFound={this.state.notFound}
            />

            <div className="mt-4 col-sm-4">
              <select
                className="form-select"
                value={this.state.selectedOption}
                onChange={this.handleSelectChange}
              >
                <option value="">Select Option</option>
                <option value="top5">Top 5 Products that Customers Buy</option>
                <option value="breakdown">Customer Breakdown</option>
                {/* <option value="customer">Customer Sales Per Store</option> */}
              </select>
            </div>

            {loading ? (
              <div className="text-center mt-4">
                <div className="spinner-border" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : (
              <>
                {this.state.selectedOption === "top5" && (
                  <Top5ProductsBuyPage transactions={objects} />
                )}
                {this.state.selectedOption === "breakdown" && (
                  <CustomerBreakdownPage transactions={this.state.enriched} />
                )}
                {this.state.selectedOption === "customer" && (
                  <CustomerSalesPerStorePage
                    transactions={this.state.enriched}
                  />
                )}
              </>
            )}
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(CustomerPage);
